export const supportAgentName = (agent) =>
  [agent?.attributes?.first_name, agent?.attributes?.last_name]
    .filter(Boolean)
    .join(" ");

// Threads carry the assignee as a bare number while the agent list is keyed
// by string ids, so the two are compared as strings.
export const findSupportAgent = (supportAgents, supportAgentId) =>
  supportAgentId === null || supportAgentId === undefined
    ? undefined
    : supportAgents?.find(
        (agent) => String(agent.id) === String(supportAgentId)
      );

// Sorted by the name shown, ignoring case and accents, so the dropdowns read
// alphabetically however the API happens to order the agents.
export const sortSupportAgentsByName = (supportAgents) =>
  [...(supportAgents ?? [])].sort((a, b) =>
    supportAgentName(a).localeCompare(supportAgentName(b), undefined, {
      sensitivity: "base",
    })
  );
